<!-- Needs to be refactored to AddressListPage -->
<template>
  <v-data-table
      :items="addresses"
      :headers="dynamicHeaders()"
      :pagination.sync="pagination"
      disable-initial-sort
      item-key="uniqueIdAddress"
      hide-actions
      no-data-text="Geen adressen gevonden"
  >
    <template v-slot:items="props">
      <td class="text-xs-left" v-if="showDate">{{ renderDate(props.item.visitDate) }}</td>
      <td class="text-xs-left" v-if="showTime">{{ renderTime(props.item.visitTime) }}</td>
      <td class="text-xs-left" v-if="showStatus">{{ renderStatus(props.item.status) }}</td>
      <td class="text-xs-left">{{ props.item.address.street }}</td>
      <td
          class="text-xs-left"
      >{{ props.item.address.homeNumber }} {{ props.item.address.addition }}
      </td>
      <td class="text-xs-left" v-if="showPostcode">{{ props.item.address.postcode }}</td>
      <td class="text-xs-left" v-if="showMunicipality">{{ props.item.address.municipality }}</td>
      <td class="text-xs-left">{{ props.item.address.city }}</td>
      <td class="text-xs-left">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ makeTextShorter(props.item.remarkPlanner) }}</span>
          </template>
          <span>{{ props.item.remarkPlanner }}</span>
        </v-tooltip>
      </td>
      <td class="text-xs-left">
        <v-btn icon flat color="primary" @click="load(props.item)">
          <v-icon class="pa-2">folder</v-icon>
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>
<script>
import {mapActions} from "vuex";
import {sharedStatusService} from '@/services/shared';

export default {
  name: "AddressListPageable",
  props: {
    addresses: Array,
    showTime: Boolean,
    showDate: Boolean,
    showMunicipality: Boolean,
    showPostcode: Boolean,
    showStatus: Boolean,
    enableBrowserBack: Boolean
  },
  data: () => ({
    pagination: {
      rowsPerPage: -1
    }
  }),
  methods: {
    ...mapActions(["loadAddress"]),
    dynamicHeaders() {
      var dHeader = [];

      if (this.showStatus) {
        dHeader.push({text: "Status", value: "status"});
      }

      if (this.showDate) {
        dHeader.push({text: "Datum", value: "visitDate"});
      }

      if (this.showTime) {
        dHeader.push({text: "Tijd", value: "visitTime"});
      }

      dHeader.push({text: "Straat", value: "address.street"});

      dHeader.push({text: "Huisnummer", value: "address.homeNumber"});

      if (this.showPostcode) {
        dHeader.push({text: "Postcode", value: "address.postcode"});
      }

      if (this.showMunicipality) {
        dHeader.push({text: "Gemeente", value: "address.municipality"});
      }
      dHeader.push({text: "Plaatsnaam", value: "address.city"});
      dHeader.push({text: "Opmerkingen planner", value: "remarkPlanner"});
      dHeader.push({text: "", sortable: false})
      return dHeader;
    },
    renderStatus(rawStatus) {
      return sharedStatusService.resolveLabel(rawStatus);
    },
    renderTime(rawTime) {
      if (rawTime !== undefined) {
        return rawTime.substring(0, 5);
      }
    },
    makeTextShorter(inputString) {
      if (!inputString) {
        return "";
      }
      if (inputString.length > 22) {
        return inputString.slice(0, 22).trim() + "...";
      }
      return inputString;
    },
    renderDate(rawDate) {
      if (rawDate === null) {
        return "";
      }
      const date = rawDate.split("T")[0];
      const dateArray = date.split("-");
      return dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0];
    },
    load(address) {
      this.loadAddress(address);
      this.$router.push("/address");
    }
  }
};
</script>